var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBbm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 251 350",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1026.94,-1497.56)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.83972,0,0,1.83972,-672.848,1338.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M923.937,264.433L923.937,276.476L995.907,276.476C999.797,276.476 1003.53,276.223 1007.11,275.739C1007.11,275.739 963.685,251.706 949.977,253.193C936.27,254.681 923.937,264.433 923.937,264.433Z",
    style: {
      fill: "rgb(133,56,63)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.83972,0,0,1.83972,-672.848,1338.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M923.937,264.433L923.937,276.476L995.907,276.476C999.797,276.476 1003.53,276.223 1007.11,275.739C1007.11,275.739 963.685,251.706 949.977,253.193C936.27,254.681 923.937,264.433 923.937,264.433Z",
    style: {
      fill: "url(#_Linear1)",
      fillRule: "nonzero",
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.83972,0,0,1.83972,-672.848,1338.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M923.937,264.433L923.937,276.476L995.907,276.476C999.797,276.476 1003.53,276.223 1007.11,275.739C1007.11,275.739 963.685,251.706 949.977,253.193C936.27,254.681 923.937,264.433 923.937,264.433Z",
    style: {
      fill: "url(#_Linear2)",
      fillRule: "nonzero",
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.08333,0,0,2.08333,-1022.49,1318.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M983.727,243.36L983.727,212.185C998.773,204.243 1055.12,182.938 1099.48,184.415C1102.62,190.295 1104.12,196.926 1104.12,203.871C1104.12,227.283 1086.88,249.324 1057.17,253.344C1057.17,253.344 1018.83,232.121 1006.72,233.435C994.618,234.748 983.727,243.36 983.727,243.36Z",
    style: {
      fill: "rgb(133,56,63)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.08333,0,0,2.08333,-1022.49,1318.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M983.727,243.36L983.727,212.185C998.773,204.243 1055.12,182.938 1099.48,184.415C1102.62,190.295 1104.12,196.926 1104.12,203.871C1104.12,227.283 1086.88,249.324 1057.17,253.344C1057.17,253.344 1018.83,232.121 1006.72,233.435C994.618,234.748 983.727,243.36 983.727,243.36Z",
    style: {
      fill: "url(#_Linear3)",
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.08333,0,0,2.08333,-1022.49,1318.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M983.727,243.36L983.727,212.185C998.773,204.243 1055.12,182.938 1099.48,184.415C1102.62,190.295 1104.12,196.926 1104.12,203.871C1104.12,227.283 1086.88,249.324 1057.17,253.344C1057.17,253.344 1018.83,232.121 1006.72,233.435C994.618,234.748 983.727,243.36 983.727,243.36Z",
    style: {
      fill: "url(#_Linear4)",
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.08333,0,0,2.08333,-1022.49,1318.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M983.727,243.36L983.727,212.185C998.773,204.243 1055.12,182.938 1099.48,184.415C1102.62,190.295 1104.12,196.926 1104.12,203.871C1104.12,227.283 1086.88,249.324 1057.17,253.344C1057.17,253.344 1018.83,232.121 1006.72,233.435C994.618,234.748 983.727,243.36 983.727,243.36Z",
    style: {
      fill: "url(#_Linear5)",
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.83972,0,0,1.83972,-672.848,1338.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M923.937,145.998L923.937,229.13C932.988,224.352 955.241,215.303 981.646,208.121C1004.94,201.783 1031.47,196.898 1055.02,197.682C1049.25,186.864 1038.56,178.291 1022.25,174.088C1022.25,174.088 966.713,195.558 923.937,145.998",
    style: {
      fill: "rgb(223,104,69)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.83972,0,0,1.83972,-672.848,1338.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M923.937,145.998L923.937,229.13C932.988,224.352 955.241,215.303 981.646,208.121C1004.94,201.783 1031.47,196.898 1055.02,197.682C1049.25,186.864 1038.56,178.291 1022.25,174.088C1022.25,174.088 966.713,195.558 923.937,145.998",
    style: {
      fill: "url(#_Linear6)",
      fillRule: "nonzero",
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.83972,0,0,1.83972,-672.848,1338.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M923.937,145.998L923.937,229.13C932.988,224.352 955.241,215.303 981.646,208.121C1004.94,201.783 1031.47,196.898 1055.02,197.682C1049.25,186.864 1038.56,178.291 1022.25,174.088C1022.25,174.088 966.713,195.558 923.937,145.998",
    style: {
      fill: "url(#_Linear7)",
      fillRule: "nonzero",
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.08333,0,0,2.08333,-1022.49,1318.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M983.727,138.775L983.727,93.522C1000.09,100.951 1022.31,107.295 1041.61,107.022C1056.08,106.816 1073.47,99.707 1083.31,96.506C1093.05,104.359 1098.12,115.706 1098.12,127.126C1098.12,142.235 1089.49,158.303 1070.55,163.58C1070.55,163.58 1021.5,182.539 983.727,138.775Z",
    style: {
      fill: "rgb(244,139,37)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.08333,0,0,2.08333,-1022.49,1318.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M983.727,138.775L983.727,93.522C1000.09,100.951 1022.31,107.295 1041.61,107.022C1056.08,106.816 1073.47,99.707 1083.31,96.506C1093.05,104.359 1098.12,115.706 1098.12,127.126C1098.12,142.235 1089.49,158.303 1070.55,163.58C1070.55,163.58 1021.5,182.539 983.727,138.775Z",
    style: {
      fill: "url(#_Linear8)",
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.08333,0,0,2.08333,-1022.49,1318.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M983.727,138.775L983.727,93.522C1000.09,100.951 1022.31,107.295 1041.61,107.022C1056.08,106.816 1073.47,99.707 1083.31,96.506C1093.05,104.359 1098.12,115.706 1098.12,127.126C1098.12,142.235 1089.49,158.303 1070.55,163.58C1070.55,163.58 1021.5,182.539 983.727,138.775Z",
    style: {
      fill: "url(#_Linear9)",
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.08333,0,0,2.08333,-1022.49,1318.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M983.727,138.775L983.727,93.522C1000.09,100.951 1022.31,107.295 1041.61,107.022C1056.08,106.816 1073.47,99.707 1083.31,96.506C1093.05,104.359 1098.12,115.706 1098.12,127.126C1098.12,142.235 1089.49,158.303 1070.55,163.58C1070.55,163.58 1021.5,182.539 983.727,138.775Z",
    style: {
      fill: "url(#_Linear10)",
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.83972,0,0,1.83972,-672.848,1338.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M999.981,86.365L923.937,86.365L923.937,94.753C942.462,103.167 967.633,110.35 989.48,110.041C1005.88,109.808 1025.56,101.758 1036.71,98.133C1027.82,90.964 1015.5,86.365 999.981,86.365Z",
    style: {
      fill: "rgb(248,173,63)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.83972,0,0,1.83972,-672.848,1338.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M999.981,86.365L923.937,86.365L923.937,94.753C942.462,103.167 967.633,110.35 989.48,110.041C1005.88,109.808 1025.56,101.758 1036.71,98.133C1027.82,90.964 1015.5,86.365 999.981,86.365Z",
    style: {
      fill: "url(#_Linear11)",
      fillRule: "nonzero",
      mixBlendMode: "soft-light"
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.19474,-21.832,21.832,8.19474,948.971,275.739)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(133,56,63)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-18.0854,-30.4066,30.4066,-18.0854,948.971,275.739)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(133,56,63)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-11.7431,-55.5469,55.5469,-11.7431,1043.92,243.686)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(133,56,63)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "rgb(105,44,50)",
      stopOpacity: 0.21
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-11.7431,-55.5469,55.5469,-11.7431,1043.92,243.686)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(133,56,63)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "rgb(105,44,50)",
      stopOpacity: 0.21
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-21.7419,61.7814,-61.7814,-21.7419,1007.72,183.478)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(133,56,63)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "white",
      stopOpacity: 0.58
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.96295,-44.7106,44.7106,5.96295,960.181,211.609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(223,104,69)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "rgb(177,83,55)",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear7",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-6.92949,-30.0056,30.0056,-6.92949,984.397,203.001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(223,104,69)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear8",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-19.7352,44.7589,-44.7589,-19.7352,1033.7,115.371)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(244,139,37)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,200,148)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear9",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.05221,-24.1544,24.1544,-2.05221,1033.8,129.903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(244,139,37)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 0.54
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear10",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.56739,-22.653,22.653,1.56739,1030.18,128.402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(244,139,37)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 0.48
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear11",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.95038,25.5519,-25.5519,-4.95038,984.095,86.4674)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(248,173,63)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,215,164)",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBbm);
export default __webpack_public_path__ + "static/media/logo-bbm.e94de54f730d705431fd1a1979b07f6c.svg";
export { ForwardRef as ReactComponent };